import Swiper from "swiper"
import {
  Autoplay,
  Navigation,
  Pagination,
  Thumbs,
  Scrollbar,
  Mousewheel,
  EffectFade,
} from "swiper/modules"

export default (params = { slidesPerView: 1 }, destroyOnResize = false) => ({
  swiper: null,
  swiperRef: null,
  initialized: false,
  productContainer: null,
  init() {
    this.initSlider()
    this.productContainer = document.getElementById("main-product")
    if (destroyOnResize) {
      this.destroyOnresize()
      window.addEventListener("resize", () => this.destroyOnresize())
    }
  },
  initSlider() {
    // Prevent reinitialization if already initialized
    if (this.swiper && this.swiper.initialized) {
      return
    }
    if (this.$el.classList.contains("swiper")) {
      const self = this
      const userOn = params.on || {}
      this.swiper = new Swiper(this.$el, {
        modules: [
          Navigation,
          Pagination,
          Thumbs,
          Autoplay,
          Scrollbar,
          Mousewheel,
          EffectFade,
        ],
        ...params,
        on: {
          init: function (swiper) {
            // Expose swiperRef for external access (matching Angular pattern)
            self.swiperRef = this
            if (userOn.init) userOn.init(swiper)
          },
          slideChange: function (swiper) {
            if (self.$el.classList.contains("modal-swiper")) {
              let index_currentSlide = swiper.realIndex
              let currentSlide = swiper.slides[index_currentSlide]
              let videoContainer =
                currentSlide && currentSlide.querySelector(".video-container")
              const video = self.productContainer && self.productContainer.querySelectorAll("video")

              if (!videoContainer && video && video.length) {
                video.forEach((vid) => {
                  vid.pause()
                })
              }
              if (currentSlide) currentSlide.click()
            }
            if (userOn.slideChange) userOn.slideChange(swiper)
          },
        },
      })
      // Also set swiperRef immediately after creation
      this.swiperRef = this.swiper
      // Keep parity with places that access instance via element.swiper.
      this.$el.swiper = this.swiper
    }
    this.initialized = true
  },
  slideToIndex(index) {
    if (this.swiper) {
      this.swiper.slideTo(index, 10)
    }
  },
  destroyOnresize() {
    if (window.innerWidth > 990 && this.swiper) {
      this.swiper.destroy()
      this.$el.swiper = null
      this.swiperRef = null
    } else {
      this.initSlider()
    }
  },
})
